'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateToDateString = require('./dateToDateString');

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

var _yesterdayEpoch = require('./yesterdayEpoch');

var _yesterdayEpoch2 = _interopRequireDefault(_yesterdayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _dateToDateString2.default)(new Date((0, _yesterdayEpoch2.default)() * 1000));
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/yesterdayString.js
// module id = 79
// module chunks = 0